import React from "react";

const MarketingSignup = () => {
  return <div class="klaviyo-form-Yi6Kfu"></div>;
};

export default MarketingSignup;
